export const MainConfig = {
    AppDetails: {
        app_name: "DugSelf", 
        app_description: "DugSelf Taxi Booking App",
        app_identifier: "com.taxi.websitecom",
        ios_app_version: "1.5", 
        android_app_version: 24
    },
    FirebaseConfig: {
        apiKey: "AIzaSyDMUBjikzkYXZGX6uFPejBqcSSpP5SUPcA",
        authDomain: "dugself-websiteco.firebaseapp.com",
        databaseURL: "https://dugself-websiteco-default-rtdb.firebaseio.com",
        projectId: "dugself-websiteco",
        storageBucket: "dugself-websiteco.appspot.com",
        messagingSenderId: "1017404567019",
        appId: "1:1017404567019:web:3ba2bcc927247e0e90fdae",
        measurementId: "G-T18YGJ6KY9"
    },
    Google_Map_Key: "AIzaSyBhFaI2KPaidvQp44ZSJpPhhcD__GcspWw",
    facebookAppId: "713966929545662"
}